import React, { createContext, useContext, useEffect, useState } from 'react';

// Cria o contexto de autenticação
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const DEBUG = false;
  const [user, setUser] = useState(null);
  const [isAuthInitialized, setIsAuthInitialized] = useState(false);

  // Função para carregar os dados de autenticação a partir do localStorage
  const loadAuthData = () => {
    try {
      if (DEBUG) console.log('=== CARREGANDO DADOS DE AUTENTICAÇÃO ===');
      const stored = localStorage.getItem('astro_user_data');
      if (DEBUG) console.log('Dados armazenados no localStorage:', stored);
      
      if (!stored) {
        console.log('Nenhum dado de usuário encontrado no localStorage');
        setUser(null);
        // Sem permissões/plano
        return false;
      }
      
      let parsed;
      try {
        parsed = JSON.parse(stored);
        if (DEBUG) console.log('Dados do usuário parseados com sucesso');
      } catch (e) {
        console.error('Erro ao fazer parse dos dados do usuário:', e);
        localStorage.removeItem('astro_user_data'); // Remove dados corrompidos
        return false;
      }
      
      if (DEBUG) console.log('Conteúdo do usuário:', JSON.stringify(parsed, null, 2));
      
      // Garante que o usuário tem a estrutura mínima necessária
      const userData = {
        ...parsed,
        is_superuser: Boolean(parsed.is_superuser),
        nivel_acesso: parseInt(parsed.nivel_acesso || '0', 10),
        email: parsed.email || ''
      };
      
      if (DEBUG) console.log('Dados do usuário normalizados:', userData);
      
      setUser(userData);
      if (DEBUG) console.log('Usuário definido no estado com sucesso');
      
      return true;
    } catch (e) {
      console.error('Erro ao ler dados de autenticação:', e);
      localStorage.removeItem('astro_auth_token');
      localStorage.removeItem('astro_user_data');
      setUser(null);
      // Sem permissões/plano
      return false;
    }
  };

  // Inicialização apenas via localStorage
  useEffect(() => {
    loadAuthData();
    setIsAuthInitialized(true);
  }, []);

  const logout = () => {
    try {
      localStorage.removeItem('astro_auth_token');
      localStorage.removeItem('astro_user_data');
    } catch (_) {}
    setUser(null);
  };

  const isAuthenticated = !!user;

  const value = {
    user,
    isAuthenticated,
    logout,
    isAuthInitialized,
    reloadAuth: loadAuthData,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider');
  }
  return context;
};
